<template>
  <!-- BSL §8 «Balon turu»: AdminLayout'ta tek örnek. Tur kendiliğinden açılmaz; kurulum penceresi
       ya da ? menüsü bellekteki isteği (bsl.turIstegi) doldurur.
       BSL-PENCERE P4: karartma + spot (tıklama geçer) + oklu balon; balon hedefi örtmez, hedefe
       tıklamak adımı ilerletir. Pencereden açılan tur kısadır (ilk + son adım). -->
  <Teleport to="body">
    <div v-if="aktif && adim" class="bsl-k-kok bsl-tur">
      <div class="bsl-tur-spot" :style="spotStil" aria-hidden="true"></div>
      <div
        ref="balon"
        class="bsl-tur-balon"
        :style="{ top: konum.top + 'px', left: konum.left + 'px' }"
        role="dialog"
        aria-modal="false"
        :aria-label="'Ekran turu, adım ' + (sira + 1) + ' / ' + adimlar.length"
        tabindex="-1"
      >
        <span class="bsl-tur-ok" :class="konum.ust ? 'bsl-tur-ok--alt' : 'bsl-tur-ok--ust'" :style="{ left: konum.ok + 'px' }" aria-hidden="true"></span>
        <p class="bsl-tur-metin">{{ adim.metin }}</p>
        <p v-if="kavramMetni" class="bsl-tur-kavram">
          <i class="pi pi-info-circle" aria-hidden="true"></i><span>{{ kavramMetni }}</span>
        </p>
        <div class="bsl-tur-alt">
          <span class="bsl-tur-sayac">{{ adimlar.length > 1 ? (sira + 1) + ' / ' + adimlar.length : 'Vurgulu alana tıklayın' }}</span>
          <button v-if="sonAdim && sonrakiTur" type="button" class="bsl-tur-ikincil" @click="sonrakineGec">{{ sonrakiTur.etiket }}</button>
          <button v-if="!sonAdim" type="button" class="bsl-tur-ikincil" @click="kapat">Geç</button>
          <button type="button" class="bsl-tur-birincil" @click="ileri">{{ sonAdim ? 'Tamam' : 'İleri' }}</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { bsl } from "@/baslarken/durum";
import { TURLAR, yolEsit } from "@/baslarken/turlar";
import { kavram } from "@/baslarken/kavramlar";

const BEKLEME_MS = 4000;

export default {
  name: "TurBalonu",
  data() {
    return {
      bsl,
      aktif: false,
      anahtar: null,
      adimlar: [],   // [{ adim, el }] — hedefi bulunan adımlar
      sira: 0,
      konum: { top: 0, left: 0, ok: 24, ust: false },
      spot: { x: 0, y: 0, w: 0, h: 0 },
      kisa: false,
    };
  },
  computed: {
    adim() {
      return this.adimlar[this.sira] ? this.adimlar[this.sira].adim : null;
    },
    sonAdim() {
      return this.sira >= this.adimlar.length - 1;
    },
    sonrakiTur() {
      const t = this.anahtar && TURLAR[this.anahtar];
      return t && t.sonraki && TURLAR[t.sonraki.anahtar] ? t.sonraki : null;
    },
    spotStil() {
      const p = this.spot;
      return { left: p.x + "px", top: p.y + "px", width: p.w + "px", height: p.h + "px" };
    },
    kavramMetni() {
      return this.adim && this.adim.kavram ? kavram(this.adim.kavram) : "";
    },
  },
  watch: {
    aktif(v) {
      bsl.turAktif = v;
    },
    "bsl.turIstegi"(istek) {
      if (istek) this.istegiIsle();
    },
    // BSL-RDV: hedef bulunamadan süre dolduysa (ör. şube seçimi bekleniyor) aynı sayfada adres
    // değişince (şube açıldı) tur bir kez daha denenir.
    "$route.query"() {
      const b = this._bekleyen;
      if (!b || this.aktif || bsl.turIstegi || this.$route.path !== b.yol) return;
      this._bekleyen = null;
      bsl.turIstegi = { anahtar: b.anahtar, yol: null, kisa: b.kisa }; // BSL-D3 (B-15): kısa tur kısa kalır
    },
    "$route.path"(yol) {
      this._bekleyen = null;
      // BSL-SAT: tur sürerken turun «devam» sayfasına geçildiyse o tur başlar (Detay → Ödeme Al).
      const devam = this.aktif && TURLAR[this.anahtar] && TURLAR[this.anahtar].devam;
      if (this.aktif) this.kapat();
      if (devam && TURLAR[devam] && yolEsit(TURLAR[devam].yol, yol) && !bsl.turIstegi)
        bsl.turIstegi = { anahtar: devam, yol: null };
      if (bsl.turIstegi) this.istegiIsle();
    },
  },
  mounted() {
    window.addEventListener("resize", this.yerlestir);
    window.addEventListener("scroll", this.yerlestir, true);
    window.addEventListener("keydown", this.tus);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.yerlestir);
    window.removeEventListener("scroll", this.yerlestir, true);
    window.removeEventListener("keydown", this.tus);
    this.hedefBirak();
    clearTimeout(this._bekle);
    clearInterval(this._izle);
  },
  methods: {
    istegiIsle() {
      const istek = bsl.turIstegi;
      const tur = istek && TURLAR[istek.anahtar];
      if (!tur) { bsl.turIstegi = null; return; }
      // Sayfa henüz açılmadıysa route değişimini bekle (istek bellekte kalır).
      if (!yolEsit(tur.yol, this.$route.path)) return;
      bsl.turIstegi = null;
      this.anahtar = istek.anahtar;
      this.kisa = !!istek.kisa;
      this._bekleyen = null;
      if (tur.sekme != null) bsl.sekmeIstegi = tur.sekme; // BSL-RDV: sayfa sekmesini açar
      this.baslat(tur);
    },
    // Sayfa geçişi + veri yüklemesi sürerken hedefler sonradan gelir: kısa aralıklarla bak,
    // en az biri çıkınca başla; süre dolarsa tur hiç açılmaz (§8: hedef yoksa adım atlanır).
    baslat(tur) {
      clearTimeout(this._bekle);
      const baslangic = Date.now();
      bsl.turHazirlik = true; // BSL-D2 (B-12): hedef aranırken kurulum penceresi dönmez
      // BSL-D2 (B-10): `bekle`li adım önceki balonun açtığı pencerede; başlangıçta görünmese de listede
      // kalır, turun başlaması için hedefi beklenmez.
      const isaretsiz = tur.adimlar.filter((a) => !a.bekle);
      const dene = () => {
        const hepsi = tur.adimlar.map((adim) => ({ adim, el: this.hedefBul(adim.hedef) }));
        const bulunan = hepsi.filter((x) => x.el);
        const sonBulunan = isaretsiz.length > 0 && this.hedefBul(isaretsiz[isaretsiz.length - 1].hedef);
        if (bulunan.length && (sonBulunan || Date.now() - baslangic > 1200)) {
          // BSL-PENCERE P4: pencereden açılan tur en çok 2 balon — nereden başlanır, nerede biter.
          this.adimlar = this.kisa
            ? (bulunan.length > 2 ? [bulunan[0], bulunan[bulunan.length - 1]] : bulunan)
            : hepsi.filter((x) => x.el || x.adim.bekle);
          this.sira = 0;
          this.aktif = true;
          bsl.turAktif = true; // turHazirlik düşmeden önce (pencere arada dönmesin)
          bsl.turHazirlik = false;
          bsl.sonTur = { anahtar: this.anahtar, zaman: Date.now() }; // BSL-TKL
          this.adimGoster();
        } else if (Date.now() - baslangic < BEKLEME_MS) {
          this._bekle = setTimeout(dene, 150);
        } else {
          bsl.turHazirlik = false;
          if (!bulunan.length) this._bekleyen = { anahtar: this.anahtar, yol: this.$route.path, kisa: this.kisa };
        }
      };
      dene();
    },
    // BSL-DYT: hedef dizi olabilir — sırayla ilk görünen seçici kazanır (belge sırası değil).
    hedefBul(secici) {
      if (Array.isArray(secici)) {
        for (const s of secici) { const el = this.hedefBul(s); if (el) return el; }
        return null;
      }
      let liste = [];
      try { liste = Array.from(document.querySelectorAll(secici)); } catch { return null; }
      return liste.find((el) => el.offsetParent !== null || el.getClientRects().length > 0) || null;
    },
    adimGoster(deneme = 0) {
      this.hedefBirak();
      const x = this.adimlar[this.sira];
      if (!x) return this.kapat();
      // Adım arasında eleman yeniden çizilmiş / pencere yeni açılmış olabilir — seçiciyle tazele.
      const el = this.hedefBul(x.adim.hedef) || (x.el && x.el.isConnected ? x.el : null);
      if (!el) {
        // BSL-D2 (B-10): `bekle`li adımın hedefi (yeni açılan pencere) 2 sn'ye kadar aranır.
        if (deneme < (x.adim.bekle ? 13 : 8)) { this._bekle = setTimeout(() => this.adimGoster(deneme + 1), 150); return; }
        if (this.sonAdim) return this.kapat();
        this.sira++;
        return this.adimGoster();
      }
      x.el = el;
      el.addEventListener("click", this.hedefTiklandi, true);
      this._hedef = el;
      const azalt = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      el.scrollIntoView({ block: "center", behavior: azalt ? "auto" : "smooth" });
      this.$nextTick(() => {
        this.yerlestir();
        setTimeout(this.yerlestir, 350);
        this.$refs.balon && this.$refs.balon.focus({ preventScroll: true });
      });
      // Sayfa kendiliğinden kayarsa / pencere açılış animasyonu sürerse spot hedefi izler.
      clearInterval(this._izle);
      this._izle = setInterval(this.yerlestir, 300);
    },
    // Hedefe tıklamak adımı ilerletir; tıklama sayfaya da geçer (spot tıklamayı tutmaz).
    hedefTiklandi() {
      if (!this.aktif) return;
      if (this.sonAdim) { setTimeout(this.kapat, 0); return; }
      this.hedefBirak();
      this.sira++;
      this._bekle = setTimeout(() => this.adimGoster(), 250);
    },
    hedefBirak() {
      if (this._hedef) this._hedef.removeEventListener("click", this.hedefTiklandi, true);
      this._hedef = null;
    },
    tus(e) {
      if (this.aktif && e.key === "Escape") this.kapat();
    },
    // Balon hedefin altında, sığmazsa üstünde; yatayda ekrana sıkıştırılır, ok hedefin ortasını gösterir.
    yerlestir() {
      if (!this.aktif) return;
      const x = this.adimlar[this.sira];
      const balon = this.$refs.balon;
      if (!x || !x.el || !balon) return;
      const t = x.el.getBoundingClientRect();
      const pay = 6;
      const r = { x: t.left - pay, y: t.top - pay, w: t.width + pay * 2, h: t.height + pay * 2 };
      this.spot = r;
      const g = balon.offsetWidth || 300;
      const y = balon.offsetHeight || 140;
      const bosluk = 14;
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const altaSigar = r.y + r.h + bosluk + y < vh - 8;
      const ustteYer = r.y - bosluk - y > 8;
      const ust = !altaSigar && ustteYer;
      let top = ust ? r.y - bosluk - y : r.y + r.h + bosluk;
      // Hiçbir yana sığmıyorsa (çok uzun hedef) ekranın altına yaslanır.
      if (!altaSigar && !ustteYer) top = vh - y - 16;
      const left = Math.max(16, Math.min(r.x + r.w / 2 - g / 2, vw - g - 16));
      const ok = Math.max(18, Math.min(r.x + r.w / 2 - left - 7, g - 32));
      this.konum = { top: Math.max(8, top), left, ok, ust };
    },
    ileri() {
      if (this.sonAdim) return this.kapat();
      this.sira++;
      this.adimGoster();
    },
    sonrakineGec() {
      const s = this.sonrakiTur;
      this.kapat();
      if (s) bsl.turIstegi = { anahtar: s.anahtar, yol: null };
    },
    kapat() {
      clearTimeout(this._bekle);
      clearInterval(this._izle);
      this.hedefBirak();
      bsl.turHazirlik = false;
      this.aktif = false;
      this.adimlar = [];
      this.sira = 0;
    },
  },
};
</script>

<style>
/* Global: tur body'ye teleport edilir. Renk tokenları KurulumPenceresi'ndeki .bsl-k-kok'tan.
   Spot tıklamayı tutmaz (pointer-events: none) — kullanıcı hedefe doğrudan tıklar. Balon her
   temada açık zemin (maket v3). */
.bsl-tur-spot {
  position: fixed;
  z-index: 1200;
  border-radius: 12px;
  box-shadow: 0 0 0 200vmax var(--bsl-karartma);
  transition: left 0.3s cubic-bezier(0.3, 0.7, 0.2, 1), top 0.3s cubic-bezier(0.3, 0.7, 0.2, 1), width 0.3s, height 0.3s;
  pointer-events: none;
}
.bsl-tur-spot::after {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 14px;
  border: 2px solid var(--bsl-vurgu);
  animation: bslTurNabiz 1.8s ease-out infinite;
}
@keyframes bslTurNabiz { 0% { opacity: 0.9; transform: scale(1); } 100% { opacity: 0; transform: scale(1.06); } }
.bsl-tur-balon {
  position: fixed;
  z-index: 1201;
  width: min(300px, calc(100vw - 32px));
  background: #fff;
  color: #121826;
  border-radius: 14px;
  padding: 14px 16px 12px;
  box-shadow: 0 24px 48px -12px rgba(0, 0, 0, 0.5);
  outline: none;
  transition: top 0.3s cubic-bezier(0.3, 0.7, 0.2, 1), left 0.3s cubic-bezier(0.3, 0.7, 0.2, 1);
}
.bsl-tur-ok { position: absolute; width: 14px; height: 14px; background: #fff; transform: rotate(45deg); }
.bsl-tur-ok--ust { top: -7px; }
.bsl-tur-ok--alt { bottom: -7px; }
.bsl-tur-metin { position: relative; margin: 0 0 10px; font-size: 14.5px; line-height: 1.45; color: #121826; }
.bsl-tur-kavram { position: relative; display: flex; gap: 6px; margin: -4px 0 10px; font-size: 12.5px; line-height: 1.4; color: #4a5567; }
.bsl-tur-kavram i { color: var(--bsl-vurgu); margin-top: 2px; }
.bsl-tur-alt { position: relative; display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.bsl-tur-sayac { flex: 1 0 auto; white-space: nowrap; font-size: 12px; font-weight: 600; color: #8590a2; font-variant-numeric: tabular-nums; }
.bsl-tur-birincil { background: var(--bsl-vurgu); color: var(--bsl-vurgu-yazi); border: 0; border-radius: 9px; padding: 8px 14px; font: inherit; font-weight: 700; font-size: 13.5px; cursor: pointer; }
.bsl-tur-ikincil { background: none; border: 0; color: #4a5567; font: inherit; font-weight: 600; font-size: 13px; padding: 8px; border-radius: 8px; cursor: pointer; }
.bsl-tur-ikincil:hover { background: #f1f4f7; }
.bsl-tur-birincil:focus-visible, .bsl-tur-ikincil:focus-visible { outline: 2px solid var(--bsl-vurgu); outline-offset: 2px; }
@media (prefers-reduced-motion: reduce) {
  .bsl-tur-spot, .bsl-tur-balon { transition: none; }
  .bsl-tur-spot::after { animation: none; }
}
</style>
